import '../stylus/style.styl';
import App from './app/App.js';
import { onLoad } from './loading/onLoad';

//=======================
// SITE LOADING
//=======================

onLoad();

// Start app when document ready
document.addEventListener('DOMContentLoaded', function () {
	new App();
});

// Animate away from page
window.addEventListener('popstate', function() {
	document.body.classList.remove('loaded');
})